// ============================================================
// [2.13.0] Retour après connexion : la page demandée avant la connexion est
// posée dans l'ÉTAT de navigation (ProtectedRoute, RequireAuth), jamais lue
// depuis l'adresse : pas de redirection ouverte. La requête est gardée
// (`/sso?audience=…` revient au consentement).
// ============================================================

import type { Location } from 'react-router-dom';

export function loginState(location: Location): { from: { pathname: string; search: string } } {
  return { from: { pathname: location.pathname, search: location.search } };
}

export function returnPathFrom(state: unknown): string {
  const from = (state as { from?: { pathname?: unknown; search?: unknown } } | null)?.from;
  const pathname = typeof from?.pathname === 'string' ? from.pathname : '';
  if (!pathname.startsWith('/') || pathname.startsWith('//') || pathname === '/login') return '/';
  const search = typeof from?.search === 'string' ? from.search : '';
  return `${pathname}${search}`;
}
